import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideComposicionLumina } from '../redux/actions';
import { nWithCommas } from '../utils';
import { ICONS } from '../assets/icons';
import M from 'materialize-css';
import { TXT_SALDO_LIQUIDO } from '../properties';
import { isNull } from 'lodash';
import { es } from 'date-fns/locale';

class ComposicionLumina extends Component {

    state = {

    }

    async componentDidUpdate(prevProps, prevState) {

        M.Tooltip.init(document.querySelectorAll('.tooltipped'), {});

    }

    componentDidMount() {
    }


    processInfo(composicion) {

        const keys = Object.keys(composicion);

        let obj = {};

        for (const k of keys) {
            if (k !== "esLumina" && k !== "totales") {
                obj[k] = [composicion[k]];
            }
        }

        return obj;
    }


    processInfoSaldoLiquido() {
        const { saldoLiquido } = this.props;

        let objReturn = {};

        for (const d of saldoLiquido) {
            let obj = {
                ValDivOrig: d.ImporteDvs,
                PrecioMdoMN: d.Divisa.trim() !== "MXP" ? d.TipoCambio : d.ImporteDvs,

            };
            if (d.Plazo === 0) {
                obj.DescRama = "Mismo día";
            } else if (d.Plazo === 1) {
                obj.DescRama = "48 hrs";
            } else if (d.Plazo === 2) {
                obj.DescRama = "24 hrs";
            }

            if (objReturn[d.Divisa]) {
                objReturn[d.Divisa].push(obj)
            } else {
                objReturn[d.Divisa] = [
                    obj
                ];
            }
        }

        return objReturn;
    }



    render() {

        const composicion = this.props.composicionLumina ? this.props.composicionLumina : false;
         const esSaldoProyectado = composicion ? composicion.esSaldoProyectado : false;

        return (
            <div id="modal_composicionLumina" className={`modal modal_composicionLumina`}>
                <div className="closeModalOk left-align">
                    <i className="material-icons cursorPointer" onClick={() => {
                        this.props.hideComposicionLumina();
                    }}>chevron_left</i> <span className="titleModal">Composición</span>
                </div>
                <div className="modal-content contentModalComposicion">
                    {
                        !composicion ?
                            <div className="row">
                                <div className="col s12 center-align">
                                    <p>Seleccione un indice válido.</p>
                                </div>

                            </div>

                            :

                            <div className="row">

                                <div className="col s12">
                                    <p className="txtBlackie ft-14">No. de contrato: {this.props.currentContrato ? this.props.currentContrato.Contrato : ""}</p>
                                    <span><p className="ft-14">{composicion.totales[0].DescripcionNivel}</p></span>
                                    <p className="boldText ft-16">
                                        {
                                            `$${nWithCommas(parseFloat(composicion.totales[0].MontoMdoMN).toFixed(2).toString())}`
                                        }
                                    </p>
                                </div>


                                {
                                    this.getComposicionDos()
                                }
                                {

                                    <React.Fragment>
                                        <div className="col s12 ft-12 left-align">
                                            *Al tipo de cambio del cierre anterior.
                                        </div>
                                        <div className="col s12 ft-12 left-align">
                                            *Incluye movimientos de efectivo pendientes de aplicar.
                                        </div>
                                    </React.Fragment>


                                }

                            </div>
                    }
                </div>
            </div>
        )
    }

    getComposicionDos = () => {
  
        if (!this.props.composicionLumina) {
            return <div></div>;
        }

          let { esSaldoProyectado } = this.props.composicionLumina;


        let objToShow = this.processInfo(this.props.composicionLumina);

          if (esSaldoProyectado) {
                objToShow = this.processInfoSaldoLiquido();
            }

        return Object.keys(objToShow).map((k, i) => {
            let dt = [];

            let esMismoDia = false;

            if (k.trim().toLowerCase() === 'mismo dia') {
                esMismoDia = true;
            }

            if (objToShow[k].length) {
                dt = Object.keys(objToShow[k][0]);
            }
            // console.log("Detalle ", dt);

            return (
                <div className="col s12" key={i}>
                    <div className="row" >
                        <div className="col s12 left-align  bgSky white-text panding-5">
                            {k}
                        </div>

                        {
                            dt.length ?
                                //Filtra los keys que son iguales a totales
                                dt.filter(key => key !== "totales").map((j, l) => {
                                    let d = [];
                                    let kd = Object.keys(objToShow[k][0][j]);
                                    // debugger;
                                    // // si tiene la propiedad detalles 
                                    // console.log("Obj to show", objToShow[k][0][j]);
                                    if (kd.length) {
                                        //filtra totales
                                        d = kd.filter(kk => kk !== "totales").map((m) => {
                                            return objToShow[k][0][j][m];
                                        });

                                        //Si d es un objeto 
                                        if (typeof d === "object" && d[0].hasOwnProperty("detalles")) {

                                            d = d[0].detalles;

                                        } else {
                                            if (d.length) {
                                                d = d[0];
                                            }
                                        }


                                    }

                                    return (
                                        <React.Fragment key={l}>
                                            <div className="col s12 left-align  bgSub subText panding-5">
                                                {j}
                                            </div>
                                            {
                                                d && d.length ?

                                                    <div className="col s12">
                                                        <div className="row mt-1">
                                                            {
                                                                esMismoDia ?
                                                                    <div className="col s6">
                                                                        <img src={ICONS.WHITEMONEDA} alt="divisa" />  <span className="emiComp">Mismo día
                                                                            <i className="material-icons right tooltipped cursorPointer"
                                                                                data-position="bottom" data-tooltip="Saldo líquido mismo día
                                                                                                    disponible para retiro antes de la 1:30pm"
                                                                            >info_outline</i></span>

                                                                    </div>
                                                                    :
                                                                    <div className="col s6 left-align">
                                                                        {d[0].Emisora} - {d[0].Serie}
                                                                    </div>
                                                            }

                                                            <div className="col s6 right-align">
                                                                ${`${nWithCommas(parseFloat(d[0].MontoMdoMN).toFixed(2).toString())}`}
                                                            </div>
                                                            {
                                                                !esMismoDia ?
                                                                    <div className="col s6 left-align txtBlackie ft-12">
                                                                        {d[0].Titulos} títulos
                                                                    </div>
                                                                    : null
                                                            }

                                                            {
                                                                !esMismoDia ?
                                                                    <div className="col s6 right-align txtBlackie ft-12">
                                                                        Precio valuación ${`${nWithCommas(parseFloat(d[0].PrecioMdoMN).toFixed(6).toString())}`}
                                                                    </div>
                                                                    : null
                                                            }
                                                        </div>
                                                        <div className="divider"></div>
                                                    </div>

                                                    : null
                                            }



                                        </React.Fragment>
                                    )
                                }) : null
                        }



                    </div>

                </div>
            )
            // let dt = j.detalle;
            // if (k.toLowerCase() === 'mismo dia') {
            //     return dt.map((v, i) => {
            //         return (
            //             <div className="col s12" key={i}>
            //                 <div className="row bgSky white-text mb-10">
            //                     <div className="col s6">
            //                         <img src={ICONS.WHITEMONEDA} alt="divisa" /> {v.Emisora ? <span className="emiComp">{v.Emisora.trim()}
            //                             <i className="material-icons right tooltipped cursorPointer"
            //                                 data-position="bottom" data-tooltip="Saldo líquido mismo día
            //                         disponible para retiro antes de la 1:30pm"
            //                             >info_outline</i></span> : ""}

            //                     </div>
            //                     <div className="col s6 right-align">
            //                         {v.Emisora.trim() !== 'MXP' ? "*" : ""}${`${nWithCommas(parseFloat(v.ValDivOrig).toFixed(2).toString())}`}
            //                     </div>
            //                 </div>

            //                 {
            //                     v.Emisora.trim() !== 'MXP'
            //                         ?
            //                         <div className="row">
            //                             <div className="col s12 right-align">
            //                                 (MXN ${`${nWithCommas(parseFloat(v.PrecioMdoMN).toFixed(2).toString())}`}) ${`${nWithCommas(parseFloat(v.MontoMdoMN).toFixed(2).toString())}`}
            //                             </div>
            //                         </div>
            //                         : null
            //                 }
            //                 {
            //                     v.detalle && v.detalle.length ?
            //                         <div>Detalle</div>
            //                         : null
            //                 }
            //             </div>
            //         )
            //     });
            // }
            // if (j.DescRama.trim().toLowerCase() === '48 hrs' || j.DescRama.trim().toLowerCase() === '24 hrs') {
            //     return dt.map((v, i) => {
            //         return (
            //             <div className="row optSide" key={i}>
            //                 <div className="col s6">
            //                     {j.DescRama.trim().toLowerCase()}
            //                 </div>
            //                 <div className="col s6 right-align">
            //                     ${`${nWithCommas(parseFloat(v.MontoMdoMN).toFixed(2).toString())}`}
            //                 </div>
            //             </div>
            //         )
            //     });
            // }


            // if (k.trim().toLowerCase() !== 'mismo día' && k.trim().toLowerCase() !== '48 hrs' && k.trim().toLowerCase() !== '24 hrs') {
            //     return dt.map((v, i) => {
            //         return (
            //             <div className="col s12" key={i}>
            //                 <div className="row" >
            //                     {
            //                         i == 0 ?
            //                             <div className="col s12 left-align  bgSky white-text panding-5">
            //                                 {j.DescRama.trim()}
            //                             </div>
            //                             : null
            //                     }

            //                     <div className="col s12 left-align  bgSub subText panding-5">
            //                         {v.DescRama.trim()}
            //                     </div>
            //                     {
            //                         v.detalle && v.detalle.length ?
            //                             v.detalle.map((j, k) => {
            //                                 return (
            //                                     <div className="col s12">
            //                                         <div className="row mt-1">
            //                                             <div className="col s6 left-align">
            //                                                 {j.Emisora} - {j.Serie}
            //                                             </div>
            //                                             <div className="col s6 right-align">
            //                                                 ${`${nWithCommas(parseFloat(j.MontoMdoMN).toFixed(2).toString())}`}
            //                                             </div>

            //                                             <div className="col s6 left-align txtBlackie ft-12">
            //                                                 {j.Titulos} títulos
            //                                             </div>

            //                                             <div className="col s6 right-align txtBlackie ft-12">
            //                                                 Precio valuación ${`${nWithCommas(parseFloat(j.PrecioMdoMN).toFixed(6).toString())}`}
            //                                             </div>
            //                                         </div>
            //                                         <div className="divider"></div>
            //                                     </div>
            //                                 )
            //                             })
            //                             : null
            //                     }
            //                 </div>
            //             </div>

            //         )
            //     });
            // }

        });

    }

}

const mapStateToProps = state => {
    let { composicionLumina } = false;
    let { dataUser, currentContrato, menuPerfil, contratosUser,
        chequera, history, saldoTotal, saldoLiquido
    } = false;

    if (state.servicesActions) {
        dataUser = state.servicesActions.dataUser || false;
        currentContrato = state.servicesActions.currentContrato || false
        contratosUser = state.servicesActions.contratosUser || false
        chequera = state.servicesActions.chequera || false



    }

    if (state.commonsActions) {
        composicionLumina = state.commonsActions.composicionLumina || false;
        menuPerfil = state.commonsActions.menuPerfil || false;
        history = state.commonsActions.history || false;
        saldoTotal = state.commonsActions.saldoTotal || 0;
        saldoLiquido = state.commonsActions.saldoLiquido || false;
    }

    return {
        composicionLumina, dataUser, currentContrato, menuPerfil, contratosUser, chequera,
        history, saldoTotal, saldoLiquido
    };
};


export default connect(mapStateToProps, { hideComposicionLumina })(ComposicionLumina)